import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IAppState } from '../../../../../../../common/state/app_state';
import { changeRoomsInDeal } from '../../../../../../state/advanced/rooms_in_deal';

import { RoomsInDeal } from './roomsInDeal';

export function mapStateToProps(state: IAppState) {
  const {
    filters: { jsonQuery },
  } = state;

  return {
    roomsInDeal: (jsonQuery.rooms_for_sale && jsonQuery.rooms_for_sale.value.gte) || 0,
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onRoomsInDealChanged: (value: number) => {
      dispatch(changeRoomsInDeal(value));
    },
  };
}

export const RoomsInDealContainer = connect(mapStateToProps, mapDispatchToProps)(RoomsInDeal);
